@if (isButtonVisible$ | async) {
  <mat-divider></mat-divider>
  <div class="feedback-button-container">
    <button
      mat-icon-button
      [matMenuTriggerFor]="feedbackList"
      #trigger="matMenuTrigger"
      (menuOpened)="registerMenuOpened(trigger)"
    >
      @if (feedbackCount$ | async; as feedbackCount) {
        <mat-icon class="material-symbols-outlined" [matBadge]="feedbackCount"
          >flag
        </mat-icon>
      } @else {
        <mat-icon [svgIcon]="addFeedbackIcon.name"></mat-icon>
      }
    </button>
  </div>

  <mat-menu #feedbackList="matMenu" [hasBackdrop]="false">
    <ng-template matMenuContent>
      <div (click)="$event.stopPropagation()">
        @switch (mode$ | async) {
          @case ('list') {
            <h3-field-feedback-list
              [feedbackItems]="feedbackItems$ | async"
              [outputId]="output.id"
            ></h3-field-feedback-list>
          }
          @case ('upsert') {
            <h3-upsert-field-feedback
              [possibleErrorTags]="output.error_tags"
            ></h3-upsert-field-feedback>
          }
        }
      </div>
    </ng-template>
  </mat-menu>
}
